interface IProps {
  data: any[]
  className?: string
  color?: string
  listClass?: string
}

const CheckProcess = ({
  data,
  className,
  color = '#726EFF',
  listClass = '',
}: IProps) => (
  <>
    <style jsx>{`
      .list--check {
        --custom-bg: ${color || '#726EFF'};
        --border-color: '#fff';
      }
    `}</style>
    <div className='recruitment-steps lg:flex lg:space-x-4 pt-12 lg:overflow-x-scroll'>
      {data.map((item, index) => (
        <div className='step flex lg:flex-col flex-row lg:flex-center content-start'>
          {color ? (
            <span
              className='check lg:mx-auto lg:m-0 m-4 shrink-0'
              style={{ backgroundColor: `#${color.replace('#', '')}` }}
            />
          ) : (
            <span
              className='check lg:mx-auto m-5'
              style={{ backgroundColor: '#726EFF' }}
            />
          )}
          <span className='lg:mx-auto text-justify lg:text-center m-4'>
            {item}
          </span>
        </div>
      ))}
    </div>
  </>
)

export default CheckProcess
